import React, {PureComponent} from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";



const testdata = [
    {
        "date": "2022-11-02",
        "amount": 500000
    },
    {
        "date": "2022-11-03",
        "amount": 681852.8
    },
    {
        "date": "2022-11-04",
        "amount": 140339
    },
    {
        "date": "2022-11-09",
        "amount": 943508.8
    },
    {
        "date": "2022-11-10",
        "amount": 534354
    },
    {
        "date": "2022-11-15",
        "amount": 256000
    },
    {
        "date": "2022-11-21",
        "amount": 662644.7
    },
    {
        "date": "2022-11-29",
        "amount": 659920
    },
    {
        "date": "2022-11-30",
        "amount": 2470728.5
    }
]

const data = [
    {
        name: "Page A",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page B",
        uv: 3000,
        pv: 1398,
        amt: 2210
    },
    {
        name: "Page C",
        uv: 2000,
        pv: 9800,
        amt: 2290
    },
    {
        name: "Page D",
        uv: 2780,
        pv: 3908,
        amt: 2000
    },
    {
        name: "Page E",
        uv: 1890,
        pv: 4800,
        amt: 2181
    },
    {
        name: "Page F",
        uv: 2390,
        pv: 3800,
        amt: 2500
    },
    {
        name: "Page G",
        uv: 3490,
        pv: 4300,
        amt: 2100
    }
];


export default class CFLineChart extends PureComponent {

    getLines() {
        return this.props.config.lines.map((d,i) => (
                <Line type="monotone" {...d} dataKey={d.dataKey} stroke={d.stroke || "#8884d8"} />
        ))
    }

    

    render() {
        // if (!this.props.data) return <></>
        return (
            <ResponsiveContainer>
                <LineChart
                    width={this.props.width || 800}
                    height={this.props.height || 400}
                    data={this.props.data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey={this.props.config.xAxis} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    {this.getLines()}
                </LineChart>
            </ResponsiveContainer>
        );
    }
}
